import type { Ref } from 'vue'

import { useApi } from '@/lib/helpers/api.helpers'
import { financeClient } from '@/lib/services/finance.service'

export const useAffiliateLinkMetrics = (linkIdRef: Ref<number | null>) => {
  const { data, isLoading, error } = useApi(async () => {
    const linkId = linkIdRef.value
    if (linkId == null) {
      return undefined
    }
    return financeClient.affiliateLinkMetricsControllerGetMetrics(linkId)
  })

  return { data, isLoading, error }
}
